export default __webpack_public_path__ + "static/media/048-Mt Fuji.fe109781.svg";